import { createContext } from 'react';
import { GranularPermissions } from 'hooks/use-has-access';

export const PermissionsContext = createContext<GranularPermissions>({});
